/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateHeaderCellUpdatingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateHeaderCellUpdatingEventArgs, _super);
    function TemplateHeaderCellUpdatingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cellInfo = null;
        _this._content = null;
        return _this;
    }
    Object.defineProperty(TemplateHeaderCellUpdatingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemplateHeaderCellUpdatingEventArgs.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (a) {
            this._content = a;
        },
        enumerable: true,
        configurable: true
    });
    TemplateHeaderCellUpdatingEventArgs.$t = markType(TemplateHeaderCellUpdatingEventArgs, 'TemplateHeaderCellUpdatingEventArgs', EventArgs.$);
    return TemplateHeaderCellUpdatingEventArgs;
}(EventArgs));
export { TemplateHeaderCellUpdatingEventArgs };
//# sourceMappingURL=TemplateHeaderCellUpdatingEventArgs.js.map
